import React, { useState, useEffect } from 'react';
import { StyleSheet, Text, View, TextInput, TouchableOpacity, Dimensions, ActivityIndicator, Button } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useSelector, useDispatch } from 'react-redux';
import { setUser } from '../redux/userSlice';
import BouncyCheckbox from "react-native-bouncy-checkbox";


export default function Login({ onSignUp }) {
    const [in_email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [keepLoggedIn, setKeepLoggedIn] = useState(false);
    const [isLoading, setIsLoading] = useState(false); // New state variable for loading status
    const [fontSize, setFontSize] = useState(16); // Initial font size
    const { width: screenWidth } = Dimensions.get('window');
    const logo = require('../assets/ipf_logo.png');
    const user = useSelector((state) => state.user);
    const dispatch = useDispatch();

  

    useEffect(() => {
        // Calculate the font size based on screen width
        const newFontSize = Math.max(12, screenWidth / 190);
        setFontSize(newFontSize);
    }, [screenWidth]);

    const handleLoginAccount = async () => {
        setIsLoading(true);
        try {
            const data = await loginUser();
            const {isAuthenticated, firebaseId, userData} = data;
            if (isAuthenticated === true) {
                const {isAuthenticated, user} = await retrieveUser(firebaseId);
                const firebase_id = user.firebase_id;
                const id = user.id;
                const firstName = user.prenom;
                const lastName = user.nom;
                const email = user.username;
                if (user !== undefined) {
                    dispatch(setUser({firebase_id, id, lastName, firstName, email, keepLoggedIn}));
                }
            } else {
                alert("Email or password is incorrect");
            }
        } catch (error) {
            console.error('Error during login:', error);
        } finally {
            setIsLoading(false);
        }
    };

    //Post request to backend to login user http://localhost:3010/api/connexion
    //Paramètres IN : in_email, password
    const loginUser = async () => {
        try {
            const response = await fetch('https://pickleball-rules-app-backend.onrender.com/api/connexion', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: in_email,
                    password: password,
                })
            });
            const data = await response.json();
            return data;
        }
        catch (error) {
            console.error('Error fetching data:', error);
        }
    }


    const retrieveUser = async (firebaseId) => {
            try {
              const response = await fetch(`https://pickleball-rules-app-backend.onrender.com/api/profil/${firebaseId}`);
              const data = await response.json();
              return data;
            } catch (error) {
              console.error('Error fetching rules:', error);
            }
    };


    return (
        <View style={styles.container}>
            <View style={{ alignSelf: 'center', justifyContent: 'center' }}>
                <Text style={styles.title}>Sign In</Text>
                
                <View style={styles.inputContainer}>
                    <View style={styles.inputWrapper}>
                        <Ionicons name="mail" size={24} color="#000" style={styles.icon} />
                        <TextInput
                            style={styles.input}
                            placeholder="Email"
                            borderColor="red"
                            onChangeText={(value) => setEmail(value)}
                            value={user?.email || in_email}
                            placeholderTextColor="#7E7E7E"
                        />
                    </View>
                    <View style={styles.inputWrapper}>
                        <Ionicons name="lock-closed" size={24} color="#000" style={styles.icon} />
                        <TextInput
                            style={styles.input}
                            placeholder="Password"
                            onChangeText={(value) => setPassword(value)}
                            //password shouldn't be saved in state
                            value={password}
                            secureTextEntry={!isPasswordVisible}
                            // value={user && user?.user?.password || 'N/A'}
                            placeholderTextColor="#7E7E7E"
                        />
                        <Ionicons
                            style={styles.icon}
                            name={isPasswordVisible ? 'eye-off' : 'eye'}
                            size={24}
                            color="gray"
                            onPress={() => setIsPasswordVisible(!isPasswordVisible)}
                        />
                    </View>
                </View>
                <View style={styles.checkboxContainer}>
                    <BouncyCheckbox
                        size={14}
                        fillColor="#683267"
                        unfillColor="white"
                        iconStyle={{ borderColor: "#683267" }}
                        innerIconStyle={{ borderWidth: 2.5 }}
                        onPress={(isChecked) => {setKeepLoggedIn(isChecked)}}
                    />
                    <Text style={[styles.checkboxText, { fontSize: fontSize + 2 }]}>Stay Signed In</Text>
                </View>
                <TouchableOpacity style={styles.button} onPress={handleLoginAccount} disabled={isLoading}>
                    {isLoading ? <ActivityIndicator size="small" color="#fff" /> : <Text style={[styles.buttonText, { fontSize: fontSize+2}]}>Sign In</Text>}
                </TouchableOpacity>
                <View style={{ borderBottomColor: '#7E7E7E', borderBottomWidth: 1.5, alignSelf: 'center', width: '12%', marginVertical: 10 }} />
                {/* <GoogleSignInButton onPress={() => googleSignIn()} /> */}
                <TouchableOpacity style={styles.signUpButton} onPress={onSignUp}>
                    <Text style={[styles.buttonText, { fontSize: fontSize + 2 }]}>Sign Up</Text>
                </TouchableOpacity>
            </View>
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#fffaeb',
        overflow: 'hidden',
        justifyContent: 'center',
    },
    title: {
        fontSize: 28,
        fontWeight: 'bold',
        marginBottom: 40,
        marginTop: 50,
        alignSelf: 'center',
        justifyContent: 'center',
    },
    inputContainer: {
        minWidth: "85%",
        maxWidth: "90%",
        marginTop: 20,
        alignSelf: 'center',
        justifyContent: 'center',
    },
    inputWrapper: {
        flexDirection: 'row',
        alignItems: 'center',
        borderBottomWidth: 1,
        borderBottomColor: '#7E7E7E',
        marginBottom: 40,
        elevation: 2,
        shadowColor: 'rgba(0,0,0,0.2)',
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.8,
        shadowRadius: 2,
        padding: 1,
    },
    icon: {
        marginRight: 10,
        color: '#7E7E7E',
        padding: 5,
    },
    input: {
        flex: 1,
        fontSize: 18,
        // color: '#000',
        overflow: 'hidden',
        padding: 5,
    },
    checkboxContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 20,
    },
    checkbox: {
        marginTop: 10,
    },
    checkboxText: {
        fontSize: 16,
    },
    button: {
        minWidth: "60%",
        width: '60%',
        height: 25,
        alignSelf: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#794a78',
        paddingHorizontal: 3,
        borderRadius: 5,
        elevation: 2,
        shadowColor: 'rgba(0,0,0,0.2)',
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.8,
        shadowRadius: 2,
        marginTop: 20,
    },
    signUpButton: {
        minWidth: "60%",
        width: '60%',
        height: 25,
        alignSelf: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#794a78',
        paddingHorizontal: 3,
        borderRadius: 5,
        elevation: 2,
        shadowColor: 'rgba(0,0,0,0.2)',
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.8,
        shadowRadius: 2,
        marginBottom: 40,
    },
    buttonText: {
        color: '#fff',
        fontWeight: 'bold',
        textAlign: 'center',
        maxHeight: 40,
        overflow: 'hidden',
        paddingVertical: 3,
    },

});
